import useOrganizationInfoDescriptionFunctions from 'components/Dashboard/hooks/useOrganizationInfoDescriptionFunctions';
import GenerateDescriptionComponent from 'components/Login/CreateProfile/GenerateDescriptionComponent';
import { useState } from 'react';
import { useNavigate } from 'react-router';
import getAppSite from 'utils/getAppSite';

const CreateProfileGenerateOrganisationDescription = () => {
  const { updateOrganizationInfoDescription } = useOrganizationInfoDescriptionFunctions();

  const [isLoading, setIsLoading] = useState(true);
  const [clientDescription, setClientDescription] = useState('');
  const [isLoadingSaveDescription, setIsLoadingSaveDescription] = useState(false);
  const navigate = useNavigate();

  const saveDescription = async () => {
    try {
      setIsLoadingSaveDescription(true);
      await updateOrganizationInfoDescription({ value: clientDescription });
      navigate({ pathname: `/create-your-profile/3` });
    } catch (error) {
      setIsLoadingSaveDescription(false);
    }
  };
  const isUsa = getAppSite() === 'usa';

  return (
    <>
      <h2 className='mb-2'>{isUsa ? 'Organization' : 'Organisation'} description</h2>
      <p className='mb-4'>
        PolicyMogul {isUsa ? 'summarizes' : 'summarises'} key political developments for you. In order to tailor them,
        we require an {isUsa ? 'organization' : 'organisation'} description. Please review what we have generated for
        you.{' '}
      </p>
      <GenerateDescriptionComponent
        clientDescriptionState={{ clientDescription, setClientDescription }}
        loadingState={{ isLoading, setIsLoading }}
      />
      <div className='flex-centered'>
        {/* 
        <Link to={`/create-your-profile/1`} className='general-button simple-link-button'>
          <span className='icon-long-arrow-left text-light-blue paragraph-p6 mr-2 d-inline-block-centered' />
          Back
        </Link> */}
        <button
          className={`btn btn-general action-button pl-3 py-1 my-4`}
          disabled={isLoading || clientDescription?.length < 100 || isLoadingSaveDescription}
          onClick={saveDescription}
        >
          {isLoadingSaveDescription ? (
            <i className='fas fa-spinner fa-spin d-inline-block-centered mr-2' />
          ) : (
            <>
              Next <span style={{ fontSize: '10px' }} className='icon-long-arrow-right d-inline-block-centered ml-2' />
            </>
          )}
        </button>
      </div>
    </>
  );
};

export default CreateProfileGenerateOrganisationDescription;
